import { clientBase } from "../common";

export const getMountedCourse = (_body) => {
  return clientBase(`v1/getUserCourseDetail`, "POST", {
    body: _body,
  });
};
